import * as React from "react";
import { forwardRef } from "react";
const SvgContract = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M1.68027 15.72V2.28051C1.68027 1.94104 1.81512 1.61548 2.05516 1.37544C2.2952 1.1354 2.62076 1.00054 2.96023 1.00054H7.68328C7.97566 0.992025 8.26216 1.08391 8.49504 1.2609C8.72792 1.4379 8.89316 1.68932 8.96324 1.97332L9.36003 3.56047H17.0398C17.3792 3.56047 17.7049 3.69531 17.9449 3.93536C18.1848 4.1754 18.3197 4.50096 18.3197 4.84043V15.72C18.3197 16.0596 18.1848 16.3851 17.9449 16.6251C17.7049 16.8652 17.3792 17 17.0398 17H2.96023C2.62076 17 2.2952 16.8652 2.05516 16.6251C1.81512 16.3851 1.68027 16.0596 1.68027 15.72Z",
	stroke: "currentColor",
	strokeWidth: 1.71429,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgContract);
export default ForwardRef;
